import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Header";
import Footer from "./Footer";
import MyOrderTab from "./profileTab/MyOrdersTab";
import MyDetailsTab from "./profileTab/MyDetailsTab";
// LOYALTY_UI_DISABLED: rikthe importin kur loyalty të shfaqet përsëri në profil.
// import LoyaltyTab from "./profileTab/LoyaltyTab";
import { LogoutAction, ProfileAction } from "../action";

const SECTIONS = {
  details: "Të dhënat",
  // loyalty: "Loyalty",
  orders: "Porositë e mia",
};

const navItemClass = (active) =>
  `flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition ${
    active
      ? "bg-neutral-100 font-medium text-neutral-900"
      : "text-neutral-700 hover:bg-neutral-50"
  }`;

export default function Profile() {
  const { section } = useParams();
  const auth = useSelector((state) => state?.productData?.users);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isKnownSection = Boolean(section && SECTIONS[section]);
  const activeSection = isKnownSection ? section : "details";
  const showMenu = !isKnownSection;
  const initials = `${auth?.user?.fname?.[0] || ""}${auth?.user?.lname?.[0] || ""}`.toUpperCase();

  useEffect(() => {
    if (!auth?.user?.email) {
      dispatch(LogoutAction());
      navigate("/");
      return;
    }
    dispatch(ProfileAction({ email: auth.user.email, id: auth.user._id }));
  }, [auth?.user?.email, auth?.user?._id, dispatch, navigate]);

  useEffect(() => {
    if (section && !SECTIONS[section]) {
      navigate("/profile", { replace: true });
      return;
    }
    if (!section && window.matchMedia("(min-width: 640px)").matches) {
      navigate("/profile/details", { replace: true });
    }
  }, [section, navigate]);

  const signout = () => {
    dispatch(LogoutAction());
    navigate("/");
  };

  const goTo = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="mx-auto w-full max-w-6xl px-4 pb-16 pt-8 sm:px-6 sm:pt-10">
        {showMenu ? (
          <h1 className="mb-6 text-2xl font-semibold tracking-tight text-neutral-900 sm:text-3xl">
            Llogaria ime
          </h1>
        ) : (
          <div className="mb-5 flex items-center gap-2 sm:hidden">
            <button
              type="button"
              onClick={() => goTo("/profile")}
              className="flex h-9 w-9 shrink-0 items-center justify-center"
              aria-label="Kthehu te llogaria"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14" />
                <path d="M5 12l4 4" />
                <path d="M5 12l4 -4" />
              </svg>
            </button>
            <h1 className="text-lg font-semibold text-neutral-900">{SECTIONS[activeSection]}</h1>
          </div>
        )}

        <div className="flex flex-col gap-8 sm:flex-row sm:items-start">
          <aside className={`${showMenu ? "block" : "hidden sm:block"} w-full sm:w-72 sm:shrink-0`}>
            <div className="rounded-2xl border border-neutral-200 bg-white p-5">
              <div className="flex items-center gap-3 border-b border-neutral-200 pb-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-neutral-300 bg-neutral-100 text-sm font-semibold uppercase text-neutral-800">
                  {initials || "A"}
                </div>
                <div className="min-w-0">
                  <p className="truncate font-semibold text-neutral-900">
                    {auth?.user?.fname} {auth?.user?.lname}
                  </p>
                  <p className="truncate text-sm text-neutral-500">{auth?.user?.email}</p>
                </div>
              </div>

              <nav className="mt-3 space-y-1" aria-label="Llogaria ime">
                <button type="button" onClick={() => goTo("/profile/details")} className={navItemClass(isKnownSection && activeSection === "details")}>
                  <svg className="h-5 w-5 text-neutral-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A8.003 8.003 0 0112 16a8.003 8.003 0 016.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="flex-1 text-left">Të dhënat</span>
                  <span className="sm:hidden text-neutral-400">›</span>
                </button>

                {/* LOYALTY_UI_DISABLED
                <button type="button" onClick={() => goTo("/profile/loyalty")} className={navItemClass(activeSection === "loyalty")}>
                  <svg className="h-5 w-5 text-neutral-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="flex-1 text-left">Loyalty</span>
                  <span className="sm:hidden text-neutral-400">›</span>
                </button>
                */}

                <button type="button" onClick={() => goTo("/profile/orders")} className={navItemClass(activeSection === "orders")}>
                  <svg className="h-5 w-5 text-neutral-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path d="M3 3h18l-2 13H5L3 3z" />
                    <circle cx="9" cy="21" r="1" />
                    <circle cx="17" cy="21" r="1" />
                  </svg>
                  <span className="flex-1 text-left">Porositë e mia</span>
                  <span className="sm:hidden text-neutral-400">›</span>
                </button>

                <Link to="/wishlist" className={navItemClass(false)}>
                  <svg className="h-5 w-5 text-neutral-500" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                  </svg>
                  <span className="flex-1">Lista e dëshirave</span>
                  <span className="sm:hidden text-neutral-400">›</span>
                </Link>

                <button type="button" onClick={signout} className="mt-2 flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-red-600 hover:bg-red-50">
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 11-4 0v-1m0-8v-1a2 2 0 114 0v1" />
                  </svg>
                  <span>Dilni</span>
                </button>
              </nav>
            </div>
          </aside>

          <section className={`${showMenu ? "hidden sm:block" : "block"} min-w-0 flex-1`}>
            <h2 className="mb-4 hidden text-xl font-semibold text-neutral-900 sm:block">
              {SECTIONS[activeSection]}
            </h2>
            {activeSection === "orders" && <MyOrderTab />}
            {activeSection === "details" && <MyDetailsTab />}
            {/* LOYALTY_UI_DISABLED: {activeSection === "loyalty" && <LoyaltyTab />} */}
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}
